export default __webpack_public_path__ + "static/media/02_photo.a4e4be7e.jpg";